<template>
  <h1 class="__card_title">
    <slot></slot>
  </h1>
</template>

<script>
export default {
  name: "card",

  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.__card_title {
  font-style: normal;
  font-weight: 600 !important;
  font-size: 20px;
  line-height: 30px;
  /* identical to box height, or 150% */

  letter-spacing: -0.01em;

  /* Dark */

  color: #23313e;
}
</style>